import React from 'react';
import { Card } from '../components/ui/card';
import { Mail, Landmark, Package } from 'lucide-react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF5F8] to-white">
      <Navbar />

      {/* Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-4xl">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">Contact Us</h1>
            <p className="text-xl text-gray-600">
              We're here to help and answer any questions you might have
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Card className="p-8 border-pink-100 shadow-lg text-center flex flex-col items-center">
              <div className="w-14 h-14 bg-pink-50 rounded-2xl flex items-center justify-center mb-6">
                <Landmark className="w-7 h-7 text-[#FF6B9D]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Business Name</h3>
              <p className="text-gray-600">LabVIEWDevops</p>
            </Card>

            <Card className="p-8 border-pink-100 shadow-lg text-center flex flex-col items-center">
              <div className="w-14 h-14 bg-pink-50 rounded-2xl flex items-center justify-center mb-6">
                <Package className="w-7 h-7 text-[#FF6B9D]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Product</h3>
              <p className="text-gray-600">Ovalu App</p>
            </Card>

            <Card className="p-8 border-pink-100 shadow-lg text-center flex flex-col items-center">
              <div className="w-14 h-14 bg-pink-50 rounded-2xl flex items-center justify-center mb-6">
                <Mail className="w-7 h-7 text-[#FF6B9D]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Email</h3>
              <p className="text-[#FF6B9D] font-semibold hover:underline">
                <a href="mailto:support@ovalu.app">support@ovalu.app</a>
              </p>
            </Card>
          </div>

          <Card className="p-8 md:p-12 border-pink-100 shadow-lg">
            <div className="prose prose-lg max-w-none text-gray-700 text-center">
              <p className="text-xl leading-relaxed">
                For any queries, support, or data-related requests, feel free to contact us. 
                Our team will get back to you as soon as possible.
              </p>
            </div>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
